<template>
  <base-form :loading="loading" class="noprogress">
    <template v-slot:header>
      {{ $t('renew_policy_number') }}
    </template>
    <base-input
      :placeholder="$t('renew_policy_number')"
      :mask="'#'.repeat(policyLength + 2)"
      :validation="$v.policy"
      v-model="policy"
      inputMode="numeric"
      inputStyle="big">
    </base-input>
    <base-button @click.prevent="onSubmit"/>
  </base-form>
</template>

<script>
import { BaseForm } from 'qic-components'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'PolicyNumber',
  components: {
    BaseForm
  },
  data () {
    return {
      loading: false,
      policy: null,
      policyLength: 10
    }
  },
  methods: {
    onSubmit () {
      this.$v.$touch()
      if (this.$v.policy.$invalid) return
      this.$router.push({ name: 'SelectPolicy', params: { policy: this.policy } })
    }
  },
  validations () {
    return {
      policy: {
        required,
        minLength: () => {
          return ((this.policyLength === this.policy.length) || (this.policyLength + 2 === this.policy.length))
        }
      }
    }
  }
}
</script>
